<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-icon small :disabled="disabled" v-on="on" @click="init">edit</v-icon>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4> BMAT</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-text-field
            label="rubro"
            v-model="parametros.rubro"
            :rules="[rules.required, rules.rubro]"
          >
          </v-text-field>

          <v-text-field
            label="porcentaje"
            v-model="parametros.porcentaje"
            :rules="[rules.required, rules.porcentaje]"
          >
          </v-text-field>

          <v-text-field
            label="segundosDesde"
            v-model="parametros.segundosDesde"
            :rules="[rules.numero]"
          >
          </v-text-field>

          <v-text-field
            label="segundosHasta"
            v-model="parametros.segundosHasta"
            :rules="[rules.numero]"
          />

          <v-text-field
            label="segundosComputables"
            v-model="parametros.segundosComputables"
            :rules="[rules.numero]"
          />

          <v-text-field
            label="distorsion"
            v-model="parametros.distorsion"
            :rules="[rules.sino]"
          />

          <v-text-field label="horaDesde" v-model="parametros.horaDesde" :rules="[rules.hora]"/>

          <v-text-field label="horaHasta" v-model="parametros.horaHasta" :rules="[rules.hora]"/>

          <v-text-field label="publicidad" v-model="parametros.publicidad" :rules="[rules.sino]"/>

          <!-- <v-text-field type=text label="Monto" v-model="nuevoMonto" autofocus/> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar" :disabled="!validForm">Actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["disabled","regla"],
  data() {
    return {
      loading: false,
      showDialog: false,
      validForm: false,
      nuevoMonto: 0,
      rules: {
        required: (value) => !!value || "Requerido.",
        numero: (value) => {
          if (value) {
            return (
              (value > 0 && value <= 1000) || "Ingrese valor entre 1 y 1000"
            );
          }
          return true;
        },
        porcentaje: (value) => {
          if (value) {
            return (value > 0 && value <= 100) || "Ingrese valor entre 1 y 100";
          }
          return true;
        },
        rubro: (value) => {
            return value == 'tv' || value == 'tv-cable' || value.startsWith('radio') || "Ingrete tv / tv-cable o radio";
        },
        hora: (value) => {
          if (value) {
            return new RegExp(/^(?:2[0-3]|[01]?[0-9]):[0-5][0-9]:[0-5][0-9]$/).test(value) || 'Ingrese hora minuto segundos en formato 24 horas (HH:MM:SS)'
          }
          return true;
        },
        sino: (value) => {
          if (value) {
            return value == "SI" || value == "NO" || "Ingrese SI o NO";
          }
          return true;
        },
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      parametros: {
        rubro: null,
        porcentaje: null,
        segundosDesde: null,
        segundosHasta: null,
        horaDesde: null,
        horaHasta: null,
        publicidad: null,
        segundosComputables: null,
        distorsion: null,
      },
    };
  },
  mounted() {
    this.nuevoMonto = this.monto;
  },
  methods: {
    init() {

      this.parametros = {
        rubro: null,
        porcentaje: null,
        segundosDesde: null,
        segundosHasta: null,
        horaDesde: null,
        horaHasta: null,
        publicidad: null,
        segundosComputables: null,
        distorsion: null,
      };

      this.regla.valores.forEach((v) => {
        if (v.nombre === "rubro") {
          this.parametros.rubro = v.valor;
        } else if (v.nombre === "porcentaje") {
          this.parametros.porcentaje = v.valor;
        } else if (v.nombre === "segundosDesde") {
          this.parametros.segundosDesde = v.valor;
        } else if (v.nombre === "segundosHasta") {
          this.parametros.segundosHasta = v.valor;
        } else if (v.nombre === "horaDesde") {
          this.parametros.horaDesde = v.valor;
        } else if (v.nombre === "horaHasta") {
          this.parametros.horaHasta = v.valor;
        } else if (v.nombre === "publicidad") {
          this.parametros.publicidad = v.valor;          
        } else if (v.nombre === "segundosComputables") {
          this.parametros.segundosComputables = v.valor;          
        } else if (v.nombre === "distorsion") {
          this.parametros.distorsion = v.valor;
        }

      });
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      // setTimeout(() => {
      //   this.$emit("nuevoMontoBolsa", {
      //     bolsaId: this.id,
      //     nuevoMontoBolsa: +this.nuevoMonto,
      //   });
      
      //this.close();
      // }, 500);

      
      const valores = [];
      for ( let key in this.parametros) {
        if (this.parametros[key]) {
          valores.push({nombre: key, valor: this.parametros[key]});
        }
      }      

      axios
        .post(
          `/regla/${this.regla.id}/actualizarParametros/`,
          valores
        )
        .then((response) => {
          console.log(response);
          this.$emit('actualizado', response.data)
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
  },
});
</script>